export default "__VITE_ASSET__DD5WwbAb__"